// extracted by mini-css-extract-plugin
export default {"MainContentContainer":"MainLayout_MainContentContainer__QT+zT"};